import Dropdown from "@stimulus-components/dropdown";

export default class extends Dropdown {
  static targets = ["button"];

  initialize() {
    this.triggerDisplay = this.triggerDisplay.bind(this);
  }

  connect() {
    super.connect();

    this.buttonTarget.addEventListener("mouseenter", this.triggerDisplay);

    this.buttonTarget.addEventListener("mouseleave", () => {
      clearTimeout(this.hoverTimeout);
    });
  }

  disconnect() {
    this.buttonTarget.removeEventListener("mouseenter", this.triggerDisplay);
  }

  hide(event) {
    super.hide(event);
  }

  triggerDisplay() {
    this.hoverTimeout = setTimeout(() => {
      if (this.buttonTarget.matches(":hover")) {
        this.menuTarget.classList.remove("hidden");
        super.transitioned = true;
      }
    }, 400);
  }
}
